import gql from 'graphql-tag';

export default gql`
  fragment ClientDepartment on ClientDepartment {
    id
    title
    department_status
    groups_total
    profiles_total
  }
`;
